import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Pillars, WhyUs, Process, Stats, Testimonials, HomeCtaStrip } from "../components/HomeSections";
import { ServicesGrid, IndustriesGrid, ServicesSectionHead } from "../components/Grids";
import { CTABanner } from "../components/CTABanner";
import { SectionHead } from "../components/Reveal";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <Pillars />

      <section className="relative bg-dg-navy py-24 sm:py-32 noise">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <ServicesSectionHead />
          <ServicesGrid />
        </div>
      </section>

      <WhyUs />
      <Process />

      <section className="relative bg-dg-light bg-grid-light pb-24 sm:pb-32">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 pt-24 sm:pt-32">
          <SectionHead
            light
            eyebrow="Who We Serve"
            title="Digital Solutions for Every Industry"
            sub="From schools to startups, healthcare to hospitality — one hub for every sector."
          />
          <IndustriesGrid />
        </div>
      </section>

      <Stats />
      <Testimonials />
      <HomeCtaStrip />
      <CTABanner />
    </main>
  );
}
